jQuery(document).ready(function ($) {
    var module_name = 'iframe';
    $('.' + module_name.replace(/_/g, '-') + '-module').each(function (index) {
        if(!modules_object['iframe'][0]['iframe_link']){
            $(".iframe-module").remove();
        }
    });
});
